module.exports = __webpack_public_path__ + "img/tour-46.4b28abae.png";